export default __webpack_public_path__ + "static/media/ea-white.ee617721.svg";